import * as React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

import { ICallbackPopupProps } from '../common/components/callback_popup/callback_popup';

// tslint:disable-next-line:no-any
function loadComponents(): Promise<{[key: string]: React.ComponentClass<any>}> {
  return new Promise((resolve, reject) => {
    require.ensure([
      '../common/components/callback_popup/callback_popup',
    ], () => {
      resolve({
        CallbackPopup: require('../common/components/callback_popup/callback_popup').default,
      });
    });
  });
}

let popupContainer: HTMLElement;

export default function initCallbackPopup() {
  const handleClose = () => {
    if (popupContainer) {
      unmountComponentAtNode(popupContainer);
    }
  };

  // tslint:disable-next-line:no-any
  (window as any).showCallbackPopup = (props: ICallbackPopupProps) => {
    loadComponents()
      .then(({ CallbackPopup }) => {
        popupContainer = document.getElementById('callback-popup-container');

        const popup = (
          <CallbackPopup
            onClose={handleClose}
            {...props}
          />
        );

        render(popup, popupContainer);
      });
  };
}



// WEBPACK FOOTER //
// ./src/bundles/callback_popup/index.tsx